import { Row, Col } from "antd";
import styled from "styled-components";
import SelectWrapper from "../input/selectWrapper";
import { InputWrapper } from "../input";
import { SearchOutlined } from "@ant-design/icons";

const StyledContent = styled.section`
  .heading-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .heading {
    font-size: 24px;
    color: #1d194d;
    font-weight: 600;
    margin: 0;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #49d3ce;
    margin: 0 12px;
  }
`;

const ContentHeader = (props) => {
  const { title, count, onSearch, onFilter } = props;
  return (
    <StyledContent>
      <Row justify="space-between" align="middle">
        <Col>
          <div className="heading-wrapper">
            <h1 className="heading">{title}</h1>
            {count ? (
              <>
                <div className="dot" />
                <h1 className="heading">{count}</h1>
              </>
            ) : null}
          </div>
        </Col>
        <Col>
          {/* <div style={{ display: "flex" }}>
            <InputWrapper
              prefix={<SearchOutlined />}
              placeholder="Search"
              onChange={onSearch}
            />
            {/* <div style={{ width: 24 }} />
            <SelectWrapper
              size="large"
              defaultValue="All"
              options={[
                { label: "All", value: "all" },
                { label: "Assiged", value: "assigned" },
                { label: "Un Assigned", value: "unassigned" },
                { label: "Completed", value: "completed" },
              ]}
            /> */}
          {/* </div>  */}
        </Col>
      </Row>
    </StyledContent>
  );
};

ContentHeader.defaultProps = {
  title: "",
  count: null,
  onSearch: () => {},
  onFilter: () => {},
};

export default ContentHeader;
